// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as PlansPlanIdRouteImport } from './routes/plans.$planId'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocalePreitineraryRouteImport } from './routes/$locale/preitinerary'
import { Route as LocaleItineraryPreviewRouteImport } from './routes/$locale/itinerary-preview'
import { Route as LocaleItineraryRouteImport } from './routes/$locale/itinerary'
import { Route as LocaleChecklistPlanIdRouteImport } from './routes/$locale/checklist.$planId'
import { Route as LocaleAuthVerifyRouteImport } from './routes/$locale/auth/verify'
import { Route as LocaleAuthDeletionStatusRouteImport } from './routes/$locale/auth/deletion-status'
import { Route as LocaleAuthAuthorizeRouteImport } from './routes/$locale/auth/authorize'
import { Route as LocaleAuthActivateRouteImport } from './routes/$locale/auth/activate'

const R500LazyRouteImport = createFileRoute('/500')()
const R404LazyRouteImport = createFileRoute('/404')()
const R400LazyRouteImport = createFileRoute('/400')()
const IndexLazyRouteImport = createFileRoute('/')()
const LocaleProfileLazyRouteImport = createFileRoute('/$locale/profile')()
const LocaleItinerariesLazyRouteImport = createFileRoute('/$locale/itineraries')()
const Locale500LazyRouteImport = createFileRoute('/$locale/500')()
const Locale404LazyRouteImport = createFileRoute('/$locale/404')()
const Locale400LazyRouteImport = createFileRoute('/$locale/400')()
const LocaleAuthProviderCallbackLazyRouteImport = createFileRoute('/$locale/auth/$provider/callback')()

const R500LazyRoute = R500LazyRouteImport.update({
            id: '/500',path: '/500',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/500.lazy').then((d) => d.Route))
const R404LazyRoute = R404LazyRouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/404.lazy').then((d) => d.Route))
const R400LazyRoute = R400LazyRouteImport.update({
            id: '/400',path: '/400',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/400.lazy').then((d) => d.Route))
const LocaleRoute = LocaleRouteImport.update({
            id: '/$locale',path: '/$locale',getParentRoute: () => rootRouteImport
          })
const IndexLazyRoute = IndexLazyRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const PlansPlanIdRoute = PlansPlanIdRouteImport.update({
            id: '/plans/$planId',path: '/plans/$planId',getParentRoute: () => rootRouteImport
          })
const LocaleIndexRoute = LocaleIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/index.lazy').then((d) => d.Route))
const LocaleProfileLazyRoute = LocaleProfileLazyRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/profile.lazy').then((d) => d.Route))
const LocaleItinerariesLazyRoute = LocaleItinerariesLazyRouteImport.update({
            id: '/itineraries',path: '/itineraries',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/itineraries.lazy').then((d) => d.Route))
const Locale500LazyRoute = Locale500LazyRouteImport.update({
            id: '/500',path: '/500',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/500.lazy').then((d) => d.Route))
const Locale404LazyRoute = Locale404LazyRouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/404.lazy').then((d) => d.Route))
const Locale400LazyRoute = Locale400LazyRouteImport.update({
            id: '/400',path: '/400',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/400.lazy').then((d) => d.Route))
const LocalePreitineraryRoute = LocalePreitineraryRouteImport.update({
            id: '/preitinerary',path: '/preitinerary',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/preitinerary.lazy').then((d) => d.Route))
const LocaleItineraryPreviewRoute = LocaleItineraryPreviewRouteImport.update({
            id: '/itinerary-preview',path: '/itinerary-preview',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/itinerary-preview.lazy').then((d) => d.Route))
const LocaleItineraryRoute = LocaleItineraryRouteImport.update({
            id: '/itinerary',path: '/itinerary',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/itinerary.lazy').then((d) => d.Route))
const LocaleChecklistPlanIdRoute = LocaleChecklistPlanIdRouteImport.update({
            id: '/checklist/$planId',path: '/checklist/$planId',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/checklist.$planId.lazy').then((d) => d.Route))
const LocaleAuthVerifyRoute = LocaleAuthVerifyRouteImport.update({
            id: '/auth/verify',path: '/auth/verify',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/auth/verify.lazy').then((d) => d.Route))
const LocaleAuthDeletionStatusRoute = LocaleAuthDeletionStatusRouteImport.update({
            id: '/auth/deletion-status',path: '/auth/deletion-status',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/auth/deletion-status.lazy').then((d) => d.Route))
const LocaleAuthAuthorizeRoute = LocaleAuthAuthorizeRouteImport.update({
            id: '/auth/authorize',path: '/auth/authorize',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/auth/authorize.lazy').then((d) => d.Route))
const LocaleAuthActivateRoute = LocaleAuthActivateRouteImport.update({
            id: '/auth/activate',path: '/auth/activate',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/auth/activate.lazy').then((d) => d.Route))
const LocaleAuthProviderCallbackLazyRoute = LocaleAuthProviderCallbackLazyRouteImport.update({
            id: '/auth/$provider/callback',path: '/auth/$provider/callback',getParentRoute: () => LocaleRoute
          }).lazy(() => import('./routes/$locale/auth/$provider/callback.lazy').then((d) => d.Route))





const LocaleRouteChildren = {
  LocaleItineraryRoute: LocaleItineraryRoute,LocaleItineraryPreviewRoute: LocaleItineraryPreviewRoute,LocalePreitineraryRoute: LocalePreitineraryRoute,Locale400LazyRoute: Locale400LazyRoute,Locale404LazyRoute: Locale404LazyRoute,Locale500LazyRoute: Locale500LazyRoute,LocaleItinerariesLazyRoute: LocaleItinerariesLazyRoute,LocaleProfileLazyRoute: LocaleProfileLazyRoute,LocaleIndexRoute: LocaleIndexRoute,LocaleAuthActivateRoute: LocaleAuthActivateRoute,LocaleAuthAuthorizeRoute: LocaleAuthAuthorizeRoute,LocaleAuthDeletionStatusRoute: LocaleAuthDeletionStatusRoute,LocaleAuthVerifyRoute: LocaleAuthVerifyRoute,LocaleChecklistPlanIdRoute: LocaleChecklistPlanIdRoute,LocaleAuthProviderCallbackLazyRoute: LocaleAuthProviderCallbackLazyRoute
}

const LocaleRouteWithChildren = LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,LocaleRoute: LocaleRouteWithChildren,R400LazyRoute: R400LazyRoute,R404LazyRoute: R404LazyRoute,R500LazyRoute: R500LazyRoute,PlansPlanIdRoute: PlansPlanIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)